// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__c7NWP","label":"Section_label__16FpI","contentWrap":"Section_contentWrap__2vuUs","footer":"Section_footer__19gUi","footerInner":"Section_footerInner__2XCVv"};